(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('llb-vertical-gallery')) {
 customElements.define('llb-vertical-gallery', class extends HTMLElement {
  connectedCallback(){this.frame=requestAnimationFrame(()=>this.setup());}
  setup(){
   this.grid=this.querySelector('.media-gallery__grid');
   if(!this.grid)return;
   this.items=Array.from(this.grid.children);
   this.controls=this.querySelector('.llb-gallery-controls');
   this.previous=this.querySelector('[data-gallery-previous]');
   this.next=this.querySelector('[data-gallery-next]');
   this.count=this.querySelector('output');
   this.abort=new AbortController();const signal=this.abort.signal;
   this.desktop=matchMedia('(min-width:750px)');
   this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
   this.index=0;this.grid.tabIndex=0;this.grid.setAttribute('aria-label',this.dataset.label);
   this.update=()=>{this.count.textContent=`${this.index+1} / ${this.items.length}`;};
   this.go=(index,instant=false)=>{
    if(!this.desktop.matches||!this.items.length)return;
    this.index=(index+this.items.length)%this.items.length;
    this.grid.scrollTo({top:this.index*this.grid.clientHeight,behavior:instant||this.reduced.matches?'instant':'smooth'});
    this.update();
   };
   this.measure=()=>{if(this.desktop.matches)this.go(this.index,true);};
   this.grid.addEventListener('wheel',event=>{
    if(!this.desktop.matches||this.items.length<2||event.ctrlKey||!event.deltaY||Math.abs(event.deltaX)>Math.abs(event.deltaY))return;
    const direction=Math.sign(event.deltaY),now=performance.now();
    const continuing=now-(this.lastWheel||0)<180;
    this.lastWheel=now;
    if(continuing||now<(this.lockUntil||0)){event.preventDefault();return;}
    // Let the page continue scrolling at the first and last photo.
    if((direction<0&&this.index===0)||(direction>0&&this.index===this.items.length-1))return;
    event.preventDefault();this.lockUntil=now+550;this.go(this.index+direction);
   },{signal,passive:false});
   this.grid.addEventListener('scroll',()=>{
    if(!this.desktop.matches)return;
    clearTimeout(this.settle);
    this.settle=setTimeout(()=>{this.index=Math.max(0,Math.min(this.items.length-1,Math.round(this.grid.scrollTop/this.grid.clientHeight)));this.update();},140);
   },{signal,passive:true});
   this.previous.addEventListener('click',()=>this.go(this.index-1),{signal});
   this.next.addEventListener('click',()=>this.go(this.index+1),{signal});
   this.grid.addEventListener('keydown',event=>{
    if(event.target!==this.grid)return;
    if(['ArrowDown','PageDown','ArrowUp','PageUp','Home','End'].includes(event.key)){
     event.preventDefault();
     this.go(event.key==='Home'?0:event.key==='End'?this.items.length-1:this.index+(['ArrowDown','PageDown'].includes(event.key)?1:-1));
    }
   },{signal});
   this.desktop.addEventListener('change',this.measure,{signal});
   this.resize=new ResizeObserver(this.measure);this.resize.observe(this.grid);
   this.controls.hidden=this.items.length<2;this.measure();this.update();
  }
  disconnectedCallback(){cancelAnimationFrame(this.frame);clearTimeout(this.settle);this.abort?.abort();this.resize?.disconnect();}
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["llb-flavor-content"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('llb-flavor-editor'))customElements.define('llb-flavor-editor',class extends HTMLElement{
 connectedCallback(){this.frame=requestAnimationFrame(()=>this.apply());}
 disconnectedCallback(){cancelAnimationFrame(this.frame);}
 apply(){
  if(this.dataset.active!=='true')return;
  const root=this.closest('.shopify-section');if(!root)return;
  const slots={summary:'[data-llb-variant-content="summary"] .text-block',details:'[data-editor-slot="details"]',brand:'[data-editor-slot="brand"]',flavor:'[data-editor-slot="flavor"]',size:'[data-editor-slot="size"]',nutrition:'[data-editor-slot="nutrition"]','nutrition-image':'[data-editor-slot="nutrition-image"]'};
  this.querySelectorAll('template[data-slot]').forEach(template=>{
   const key=template.dataset.slot;
   if(key==='gallery'){
    const gallery=root.querySelector('media-gallery');
    if(gallery){const replacement=template.content.cloneNode(true);const wrapper=gallery.closest('llb-vertical-gallery');if(wrapper){const updated=wrapper.cloneNode(true);updated.querySelector('media-gallery').replaceChildren(replacement);wrapper.replaceWith(updated);}else{gallery.replaceChildren(replacement);}}
   }else{const target=root.querySelector(slots[key]);if(target)target.replaceChildren(template.content.cloneNode(true));}
  });
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["llb-product-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('llb-product-tabs')) {
  customElements.define('llb-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      const panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (!tabs.length || tabs.length !== panels.length) return;
      const activate = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(next, true); }
        });
      });
      this.querySelector('[role="tablist"]').hidden = false;
      this.dataset.enhanced = 'true';
      activate(0);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
